import React from "react";

interface CrumbProps {
  children: string;
  maxLength?: number;
}

const Crumb: React.FC<CrumbProps> = ({
  children: text,
  maxLength = 25,
}) => {
  if (!text || text.length <= maxLength) {
    return <>{text}</>;
  }

  return (
    <span className="truncate-inline" title={text}>
      {text.slice(0, maxLength)}...
    </span>
  );
};

export default Crumb;
